import styled from 'styled-components'

export const CidItem = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
`
